module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Canonical Theology")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Every age presents its particular theological challenges. Luther rightly argued in his context that justification is the article by which the church stands or falls. In our day Alister McGrath has left us all in his debt with his magisterial "), _c('i', [_vm._v("Iustitia Dei: A History of the Doctrine of Justification")]), _vm._v(", which is now in its third edition. The new perspective on Paul has indeed led to a lively debate about justification, but I doubt that this important doctrine could or should be seen as just as critical as it was in Luther’s day.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Indeed, the debate about justification rests on a pre-understanding of Scripture as the canonical literature of the Christian church and it is here that we find one of the most serious issues facing Christian faith today. Already in 1975 David Dungan predicted that major challenges to traditional understandings of the canon were on the horizon,"), _c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1"
    }
  }, [_vm._v("1")])]), _vm._v(" and he has proved to be correct as the “Canon Debate” has moved front and center."), _c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When I was at Oxford I had the privilege of getting to know Roger Beckwith and he kindly gave me mimeographed copies of what became his seminal "), _c('i', [_vm._v("The Old Testament Canon of the New Testament Church and Its Background in Early Judaism")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "fn3"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3"
    }
  }, [_vm._v("3")])]), _vm._v(" James Barr and John Barton were also at Oxford during this time and they articulated liberal views of canonicity often highly critical "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("of Beckwith. During these years, under the influence of Karl Barth, Brevard Childs’s canonical hermeneutic emerged as he courageously sought to redirect biblical studies along lines which took the Bible seriously as canon while retaining the insights of historical criticism. Several of Childs’s students, notably Christopher Seitz and Stephen Chapman, as well as many others, have continued to develop Childs’s canonical approach.")]), _c('a', {
    attrs: {
      "id": "fn4"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4"
    }
  }, [_vm._v("4")])]), _vm._v(" In recent decades Stephen Dempster has done important work on canonical biblical interpretation within the evangelical tradition and Michael Kruger has addressed the issue of canon in his works "), _c('i', [_vm._v("Canon Revisited: Establishing the Origins and Authority of the New Testament Books")]), _c('a', {
    attrs: {
      "id": "fn5"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5"
    }
  }, [_vm._v("5")])]), _vm._v(" and "), _c('i', [_vm._v("The Question of Canon: Challenging the Status Quo in the New Testament Debate")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "fn6"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The issues involved in the canon debate are complex and multiple."), _c('a', {
    attrs: {
      "id": "fn7"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7"
    }
  }, [_vm._v("7")])]), _vm._v(" At their heart, however, as John shows in this book, they come down to where we locate final authority, whether in Scripture or some version of “the community.” The issue of authority is central to the current challenges facing modernity, and this is as true of Western societies as it is of the church. Thus, where we land on canonicity really matters! There is hardly a major issue dividing Christians today that does not come down finally to the question of the "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("intrinsic authority of Scripture, i.e., canonicity. In our day it takes courage and wisdom to grasp the nettle of canonicity and John Peckham manifests both in this important new book.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The role of the theologian is to reflect on Scripture and the tradition and to articulate the contours of Christian faith for a particular age. In this book John does just that. He takes hold of what I argue is one of the most pressing issues facing the church today, and does so clearly, with a refreshing and astonishingly wide range of engagement, pushing towards the conclusion that Scripture is intrinsically authoritative as the Word of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Much of the above work referred to relates to biblical studies rather than theology. In my view, contrary to the history of religions approach, theology is indispensable to the canon debate, "), _c('i', [_vm._v("and")]), _vm._v(" canonicity is vital for healthy theology. Part of the importance of this book lies in the fact that as a theologian John moves beyond the canon debate to develop a theological method built on the intrinsic authority of Scripture and then devotes several chapters to testing his model in relation to themes such as the doctrine of the Trinity and the doctrine of the love of God, about which he has already published two important books.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In my view this is precisely the sort of work we need our best and brightest theologians to do today. Doubtless readers will disagree with John at points. I myself look forward to discussing and debating aspects of the book with him! But wherever we land on these issues, it is to John’s credit that he has put the issues so clearly, firmly, winsomely, and integrally on the table for discussion, and for this I am profoundly grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "EX2a"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAIG")]), _vm._v(" G. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTHOLOMEW")])]), _vm._v(" "), _c('p', {
    staticClass: "EX2"
  }, [_c('i', [_vm._v("Hamilton, Ontario")])]), _vm._v(" "), _c('p', {
    staticClass: "EX2"
  }, [_c('i', [_vm._v("March 2016")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". D. L. Dungan, “The New Testament Canon in Recent Study,” "), _c('i', [_vm._v("Int")]), _vm._v(" 29 (1975): 339-51.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Cf. Lee Martin McDonald and James A. Sanders, eds., "), _c('i', [_vm._v("The Canon Debate")]), _vm._v(" (Peabody, MA: Hendrickson, 2009). A strength of Brevard Childs’s work is his familiarity with German debates around canon. See his and the other essays in Craig G. Bartholomew et al., eds., "), _c('i', [_vm._v("Canon and Biblical Interpretation")]), _vm._v(", Scripture and Hermeneutics Series 7 (Milton Keynes: Paternoster; Grand Rapids: Zondervan, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". Eugene, OR: Wipf and Stock, 1985, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". See most recently Stephen Chapman, "), _c('i', [_vm._v("1 Samuel as Christian Scripture: A Theological Commentary")]), _vm._v(" (Grand Rapids: Eerdmans, 2016); Christopher R. Seitz, "), _c('i', [_vm._v("Joel")]), _vm._v(", International Theological Commentary (London: Bloomsbury, 2016).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Wheaton, IL: Crossway, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Downers Grove, IL: InterVarsity, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". See Craig G. Bartholomew, "), _c('i', [_vm._v("Introducing Biblical Hermeneutics: A Comprehensive Framework for Hearing God in Scripture")]), _vm._v(" (Grand Rapids: Baker Academic, 2015) 251-78.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715470c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 69
// module chunks = 0